import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductGet } from '@app/services/product.service';

@Component({
    selector: 'tt-product-edit',
    templateUrl: './product-edit.component.html',
    styleUrls: ['./product-edit.component.css'],
})
export class ProductEditComponent {
    @Input()
    public params?: ProductGet;

    @Output()
    public paramsChange = new EventEmitter<ProductGet>();
}
